import React from 'react';
import Viewer from '../../Viewer';
import { extConfigFullscreen } from '../../../Editor/presets/DeviationDescription/config';
import type { ExternalReactRenderers } from '../../../Editor/types';
import cn from 'classnames';
import { Measureable } from '../../types';

import s from './CustomExclusiveQuestion.scss';

export interface Props extends Measureable {
  contentJson: any;
  className?: string;
  externalRenderers: ExternalReactRenderers;
}

const CustomExclusiveQuestionViewer = React.forwardRef<HTMLDivElement, Props>(
  (
    { contentJson, className, externalRenderers, cookieType, defaultSize },
    ref
  ) => {
    return (
      <Viewer
        presetId="custom-exclusive-question"
        contentJson={contentJson}
        className={cn(s['root'], className)}
        extensionConfig={extConfigFullscreen}
        externalRenderers={externalRenderers}
        cookieType={cookieType}
        defaultSize={defaultSize}
        ref={ref}
      />
    );
  }
);
CustomExclusiveQuestionViewer.displayName = 'CustomExclusiveQuestionViewer';

export default CustomExclusiveQuestionViewer;
